import React from 'react';
import { render } from 'react-dom';
import BkToolsApp from 'bk-web-app/BkToolsApp';

render(<BkToolsApp />, document.getElementById('container'));

if (module.hot) {
    module.hot.accept();
}